import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Spinner,
  Button,
} from "@fluentui/react-components";

// Components
import { useNotify } from "../../../shared/components/SuperToast";

// Business logic
import { useSelectedMailboxesContext } from "../context/SelectedMailboxContext";
import { useDeleteMailbox } from "../hooks/useMailboxMutations";
import { useTranslation } from "react-i18next";

function MailboxDeleteDialog({ isOpen, setIsOpen }) {
  const { t } = useTranslation();
  const { value: selectedMailboxes } = useSelectedMailboxesContext();
  const { notify } = useNotify();

  const {
    mutate: mutateDeleteMailbox,
    isPending,
    error,
  } = useDeleteMailbox(
    "mailboxes",
    () => {
      notify(t("item.messages.deleted", { name: selectedMailboxes[0].name }), "success");
      setIsOpen(false);
    },
    null,
  );

  const handleConfirmation = () => {
    const publicId = selectedMailboxes?.[0]?.public_id;
    if (!publicId) throw new Error("No valid ID for mailbox");
    console.log(`Deleting mailbox with id ${publicId}`);
    mutateDeleteMailbox(publicId);
  };

  if (!selectedMailboxes?.[0]) return null;

  return (
    <Dialog modalType="alert" open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{selectedMailboxes[0]?.name}</DialogTitle>
          <DialogContent>
            {t("item.questions.delete", {
              name: selectedMailboxes[0]?.name,
            })}
            {error && <div style={{ color: "red" }}>{error.message}</div>}
          </DialogContent>
        </DialogBody>
        <DialogActions>
          <Button appearance="primary" disabled={isPending} onClick={handleConfirmation}>
            {isPending ? <Spinner size="tiny" style={{}} /> : t("generic.confirm")}
          </Button>
          <Button appearance="secondary" disabled={isPending} onClick={() => setIsOpen(false)}>
            {t("generic.cancel")}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}

export default MailboxDeleteDialog;
